import { PageWrapper } from '../../components/PageWrapper';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import bagShop from '../../pages/jackpot/assets/bag-shop.svg';
import gift from '../../pages/jackpot/assets/gift.svg';
import card from '../../pages/jackpot/assets/card.svg';
import banner from '../../pages/jackpot/assets/banner.svg';
import cgu from '../../pdf/CGU.pdf';
import { getCompanyStoresByStoreId } from '../../actions/storeActions';
import { useEffect, useState } from 'react';
import useAxios from '../../axios/useAxios';
import { CreateFidCardBottomLayer } from './assets/components/createFidCardBottomLayer';
import { FaChevronLeft, FaChevronDown } from 'react-icons/fa';
import { CREATE_FID_CARD_CASHBACK, SCAN } from '../../constants/routes';
import { LoadingCreationFidCard } from './assets/components/loadingCreationFidCard';
import { formatPriceWithEuro } from '../../utils/StringUtils';
import { useJackpotMatch } from '../../hooks/useJackpotMatch';
import BackButton from '../../components/button/BackButton';
import clsx from 'clsx';
export const CreateFidCardCashback = () => {
    const navigate = useNavigate();
    const { store } = useSelector((state) => state.store);
    const [companyStores, setCompanyStores] = useState([]);
    const { cartItems } = useSelector((state) => state.cart)
    const user = useSelector((state) => state.user);
    const axiosInstance = useAxios();
    const [isActiveStoreValid, setIsActiveStoreValid] = useState(false);
    const [isFavoriteStoreValid, setIsFavoriteStoreValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCreatingCard, setIsCreatingCard] = useState(false);
    const [cardData, setCardData] = useState(null);
    const [isFeaturesOpen, setIsFeaturesOpen] = useState(false);
    const {
        totalAddedToJackpot,
    } = useJackpotMatch({
        axiosInstance,
        user,
        cartItems,
        store,
        shouldFetch: true,
    });
    const features = [
        {
            icon: card,
            title: 'Paye avec tes euros cagnottés',
            description: 'Cumules des euros sur chaque passage et paye avec ta cagnotte quand tu le souhaites'
        },
        {
            icon: gift,
            title: "Au 10ème passage, c'est cadeau",
            description: 'À ton 10ème passage, 10% de ton panier est reversé en € dans ta cagnotte '
        },
        {
            icon: bagShop,
            title: 'Cagnotte sur des milliers de produits',
            description: 'Une large sélection de produits éligibles au cashback'
        }
    ]
    useEffect(() => {
        if (!store?.id) return;

        const fetchData = async () => {
            setIsLoading(true);

            try {
                const storesData = await getCompanyStoresByStoreId(axiosInstance, store.id);
                setCompanyStores(storesData?.stores);

                const favoriteStoreId = user?.favoriteStore;

                const isStoreValid = favoriteStoreId &&
                    storesData?.stores.some((s) => s.id === favoriteStoreId);
                setIsFavoriteStoreValid(isStoreValid);

                const activeFidCard = await axiosInstance.get(`/company/${store.id}/fid`);
                const activeFidCardInfo = activeFidCard.data;
                setIsActiveStoreValid(activeFidCardInfo);

            } catch (error) {
                console.error("Erreur lors du chargement des données:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [store?.id, user.favoriteStore]);

    const handleCardCreated = (newCardData) => {
        setCardData(newCardData);
        setIsCreatingCard(false);
        setTimeout(() => {
            navigate(SCAN, { state: { previousRoute: CREATE_FID_CARD_CASHBACK } });
        }, 3000);
    };

    const handleStartCreation = () => {
        setIsCreatingCard(true);
    };

    const handleError = () => {
        setIsCreatingCard(false);
    };

    return (
        <div className="pb-[250px] relative pt-[60px] min-h-[100dvh] bg-gradient-violet  p-6 px-8">
            {(isCreatingCard || cardData) && <LoadingCreationFidCard isLoading={isCreatingCard} cardData={cardData} />}
            <BackButton 
                isWhite={true} 
                onClick={() => navigate(SCAN, { state: { previousRoute: CREATE_FID_CARD_CASHBACK} })} 
                isFixed={true} 
            />
            <div className='flex flex-col'>

                {/* Cashback banner section */}
                <div className='flex flex-col gap-6 pt-6 animate-section-enter' style={{ animationDelay: '100ms' }}>
                    <div className='w-full flex flex-col gap-8 justify-center items-center relative'>
                        <img src={banner} className='w-[140px] h-[140px] object-contain' alt="banner" />
                        <div
                            data-text={"+" + formatPriceWithEuro(totalAddedToJackpot())}
                            className='geomanistMedium font-semibold text-white cartoon-text'
                        >
                            +{formatPriceWithEuro(totalAddedToJackpot())}
                        </div>
                    </div>
                    <div 
                        className='w-full text-[#ffffffc8] text-center text-5xl geomanistBold transition-all duration-300' 
                        style={{ 
                            WebkitTextStroke: '2px #A340F1', 
                            paintOrder: 'stroke fill', 
                            borderBottom: '1px solid rgba(255, 255, 255, 0.3)', 
                            borderBottomColor: isFeaturesOpen ? 'transparent' : 'rgba(255, 255, 255, 0.3)',
                            paddingBottom: '10px'
                        }}
                    >
                        AVEC LA CARTE FIDÉLITÉ
                    </div>
                </div>

                {/* Features dropdown section */}
                <div className={clsx('flex flex-col mb-12 rounded-2xl bg-black overflow-hidden transition-all duration-300 ease-out', { 'bg-opacity-20 backdrop-blur-[10px]': isFeaturesOpen , 'bg-opacity-0 backdrop-blur-[0px]': !isFeaturesOpen})}>
                    <button 
                        onClick={() => setIsFeaturesOpen(!isFeaturesOpen)}
                        className='flex items-center justify-between w-full p-6'
                    >
                        <span className='text-2xl geomanistRegular font-semibold text-white'>Voir tous les avantages</span>
                        <FaChevronDown 
                            fill="#fff"
                            className={`w-5 h-5 transition-transform duration-300 ease-out ${isFeaturesOpen ? 'rotate-180' : ''}`}
                        />
                    </button>
                    <div 
                        className={`grid transition-all duration-300 ease-out ${isFeaturesOpen ? 'grid-rows-[1fr] opacity-100 max-h-[200px]' : 'grid-rows-[0fr] opacity-0 max-h-[0px]'}`}
                    >
                        <div className='h-[1px] bg-white opacity-40 mb-6'></div>
                        <div className='overflow-hidden'>
                            <div className='flex flex-col gap-6 px-6 pb-6'>
                                {features.map((feature, index) => (
                                    <div 
                                        key={index} 
                                        className={`flex items-center gap-6 ${index === 1 ? 'border-solid border-r-0 border-l-0 !border-y border-[#f7f7f714] py-6' : ''}`}
                                    >
                                        <img className='w-[32px] h-[32px] object-contain' src={feature.icon} alt="feature icon" />
                                        <div className='flex flex-col gap-2'>
                                            <div className='text-2xl geomanistRegular font-semibold text-white'>{feature.title}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* CGU text section */}
                <span className='text-xl text-white geomanistRegular text-opacity-80 font-semibold animate-section-enter [word-spacing:6px]' style={{ animationDelay: '500ms' }}>
                    En cliquant sur le bouton, "Créer en 1 clic" j'accepte les <a href={cgu} className='underline '>conditions d'utilisation de la carte de fidélité</a>, ainsi que le traitement de mes données personnelles.
                </span>
            </div>
            <CreateFidCardBottomLayer
                user={user}
                isLoading={isLoading}
                favoriteStoreIsMatch={isFavoriteStoreValid}
                companyStores={companyStores}
                isActiveStoreValid={isActiveStoreValid}
                storeId={store?.id}
                onCardCreated={handleCardCreated}
                onStartCreation={handleStartCreation}
                onError={handleError}
                store={store}
            />
        </div>
    )

}
